import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_DUPLICATE } from './router';

export default registerRouteForModule(router);

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Duplicate',
        name: 'Duplicate',
        icon: 'fas fa-clone'
    },
    {
        parent: 'Multiplayer.Duplicate',
        key: 'Item',
        name: 'Item',
        icon: 'fas fa-leaf',
        route: { name: ROUTE_NAME_DUPLICATE.ITEM.INDEX }
    },
    {
        parent: 'Multiplayer.Duplicate',
        key: 'Cycle',
        name: 'Cycle',
        icon: 'fas fa-sync-alt',
        route: { name: ROUTE_NAME_DUPLICATE.CYCLE.INDEX }
    },
    {
        parent: 'Multiplayer.Duplicate',
        key: 'Setting',
        name: 'Setting',
        icon: 'fas fa-clone',
        route: { name: ROUTE_NAME_DUPLICATE.SETTING }
    }
]);
